import { BlockStack, Text } from '@shopify/polaris';

/**
 * Small metric card used in 3- or 4-column grids on results, product detail,
 * and bulk-fix screens. Mirrors the .metric-card from the design system.
 */
export function MetricCard({
  label,
  value,
  sub,
  tone,
  center,
}: {
  label: string;
  value: string | number;
  sub?: string;
  tone?: 'critical' | 'warning' | 'success' | 'subdued';
  center?: boolean;
}): JSX.Element {
  const toneColors: Record<string, string> = {
    critical: '#D72C0D',
    warning: '#B98900',
    success: '#008060',
    subdued: 'var(--p-color-text-subdued)',
  };
  const color = tone ? toneColors[tone] : 'var(--p-color-text)';

  return (
    <div
      style={{
        background: 'var(--p-color-bg-surface-secondary)',
        borderRadius: 8,
        padding: '12px 14px',
        textAlign: center ? 'center' : undefined,
      }}
    >
      <BlockStack gap="050">
        <Text as="p" variant="bodySm" tone="subdued">{label}</Text>
        <div style={{ fontSize: 22, fontWeight: 700, color }}>{value}</div>
        {sub && <Text as="p" variant="bodySm" tone="subdued">{sub}</Text>}
      </BlockStack>
    </div>
  );
}
